import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to element matching `location.hash` on route/hash change. */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }
    const id = hash.replace(/^#/, "");
    // Wait a tick for the target route to render
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}
